module.exports = __webpack_public_path__ + "./images/70a935ef81a024129e23a90355f6366e.webp";